// notification store module

const unknownErrorMessage = '不明なエラーが発生しました。連続して発生する場合は設定画面よりアプリの更新を行ってください。'
class NotifyMessage {
  constructor(text = '', type = 'info', multiline = false, isUnknownError = false) {
    if (isUnknownError) {
      this.text = unknownErrorMessage
    } else {
      this.text = text
    }
    this.type = type
    this.multiline = multiline
    this.createdAt = new Date()
  }
}

// define state values
const state = () => ({
  messages: []
})

const getters = {
  /**
   * 通知メッセージが存在しているかどうかを返す
   *
   * @param {*} state
   * @returns boolean
   */
  existMessage(state) {
    if (state.messages.length > 0) {
      return true
    }
    return false
  },
  latestMessage(state) {
    if (state.messages.length > 0) {
      return state.messages[0]
    }
    return null
  }
}

const mutations = {
  /**
   * 通知を設定する
   * 呼び出す際には `notify/set` のように module 名を明示的に指定する
   * 
   * ex).
    ```js
    this.$store.commit('notify/set', {
        type: 'info',
        message: 'foo'
      })
    ```
   *
   * @param {*} state
   * @param {{ type: string, message: string, multiline: boolean, isUnknownError: boolean }} payload
   */
  set(state, { message, type, multiline, isUnknownError }) {
    const msg = new NotifyMessage(message, type, multiline, isUnknownError)
    state.messages.unshift(msg)
  },
  /**
   * 通知を消去する
   *
   * @param {*} state
   */
  remove(state, msg) {
    const idx = state.messages.indexOf(msg)
    if (idx > -1) state.messages.slice(idx, 1)
  },
  /**
   * 通知の配列の最後を消去する
   *
   * @param {*} state
   */
  removeLast(state) {
    if (state.messages.length > 0) {
      state.messages.pop()
    }
  },

  clear(state) {
    state.messages = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
